import type { AffAircraftEntity } from '../../../components/explorers/affExplorer/affServiceAdapter';

/**
 * Map an AFF marker's feature properties onto the shape the aircraft modals
 * expect.
 *
 * The marker feed (GET /api/aff/ac) predates the explorer and names things
 * differently — `altitude` rather than `alt`, epoch milliseconds rather than
 * ISO timestamps. Mapping in one tested place is what lets a map click and the
 * grid's View button open the same modal with the same content.
 */
// The feed's epochs come from EXTRACT(EPOCH …) * 1000, which pg returns as
// text ("1789428357000.000000"), so a numeric string is an epoch too (#798).
const toIso = (raw: unknown): string | undefined =>
  raw == null || raw === ''
    ? undefined
    : typeof raw === 'number' || /^\d+(\.\d+)?$/.test(String(raw))
      ? new Date(Number(raw)).toISOString()
      : String(raw);

export function markerPropsToAircraft(
  props: Record<string, any>,
  coords: [number, number],
): AffAircraftEntity {
  return {
    _id: String(props.esn ?? ''),
    esn: String(props.esn ?? ''),
    name: props.name,
    callsign: props.callsign,
    airframe: props.airframe,
    make: props.make,
    model: props.model,
    owner: props.owner,
    operationalFunction: props.operationalFunction,
    groupDesignator: props.groupDesignator,
    lon: coords[0],
    lat: coords[1],
    alt: props.altitude ?? props.alt,
    speed: props.speed,
    heading: props.heading,
    stale: props.stale,
    recordAgeMins: props.recordAgeMins,
    source: props.source,
    positionTimestamp: toIso(props.positionTimestamp),
    createdAt: toIso(props.createdAt),
  } as AffAircraftEntity;
}
